module.exports = __webpack_public_path__ + "img/ar30_samurai02skin_shop.0006947f.png";